<template>
    <div class="AddBox card playerBoxAdd">
        <img class="cardLogo" src="../assets/addTeam2.png">
        <div class="inputHolder">
            <input type="text" :value="value" @input="$emit('input', $event.target.value)" v-on:keyup.enter="$emit('add')" v-bind:placeholder="placeholderText">
            
        </div>
        <div class="addBtn">
            <img src="@/assets/addButton.png" class="addButton green-glow" v-if="status == 'ok' || status == 'error' || status == undefined" v-on:click="$emit('add')">
            
            <loader class="loaderElement" v-bind:status="status"></loader>
        </div>
    </div>
</template>


<script>
import Loader from '@/components/Loader.vue'
export default {
    name: 'AddBox',
    props: ["value","placeholderText","status"],

    components: {
        Loader
    }
}
</script>


<style scoped>
.AddBox{
    display: grid;
    grid-template-columns: 100px auto 50px;
    grid-template-areas:
    'cardLogo inputHolder addBtn'
}
.cardLogo{
    grid-area: cardLogo;
}
.inputHolder{
    grid-area: inputHolder;
    align-self: center;
    margin-left: 10px;
}
.addBtn{
    grid-area: addBtn;
    text-align: center;
    margin: auto;
}
.loaderElement{
    margin: auto;
}
.card{
    background-image: url();
    background-color: #0000003f;
    cursor: default;
}

@media (max-width: 600px) {
    .inputHolder{
        width: 100%;
    }
    input{
        width: 100%;
    }
}
.addButton{
    width: 2em;
    border-radius: 50%;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AddBox.vue